import { ColumnDef } from "@tanstack/react-table";
import { z, ZodObject, ZodRawShape } from "zod";
import { useTranslation } from "react-i18next";

export const ShelvingUnitTableColumns: ColumnDef<
  z.infer<ZodObject<ZodRawShape>>
>[] = [
  {
    accessorKey: "identifier",
    header: "identifier",
  },
  {
    id: "path.warehouse.name",
    accessorKey: "path.warehouse.name",
    header: "warehouse",
  },
  {
    id: "path.warehouse.status",
    accessorKey: "path.warehouse.status",
    header: "status",
    cell: ({ row }) => {
      const { t } = useTranslation("common");

      if (row.original.path?.warehouse?.status === true) {
        return t("Active");
      }

      return t("Inactive");
    },
  },
];
